import React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import { AppBarBottom, CompDiaria, CompMensalista, CompPedido } from '../../../Complex/'
import FiltroAvulsos from './FiltroAvulsos'
import { Loading, SearchAlert } from '../../../Simple'
import RouterHook from '../../../../contexts/RouterHook'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'
import { IoChevronBack } from 'react-icons/io5'

import { stMob } from '../styles'

export default function MobileAU() {
  const serverRouter = RouterHook()
  const containListRef = React.useRef(null)
  const { sttCtxAgend, loadAgend, actionsAgend } = React.useContext(AgendamentoContext)

  React.useEffect(() => {
    if (sttCtxAgend.bttAgSel === 'avulsos') actionsAgend.BuscarAgendamentosAvulsos(true)
    else if (sttCtxAgend.bttAgSel === 'fixos') actionsAgend.BuscarMensalistasUsuario(true)
    else if (sttCtxAgend.bttAgSel === 'diarias') actionsAgend.BuscarDiariasUsuario(true)
  }, [sttCtxAgend.bttAgSel, sttCtxAgend.avulsoSel, sttCtxAgend.typePed])

  React.useEffect(() => {
    const handleScroll = () => {
      if (containListRef.current) {
        const { scrollTop, clientHeight, scrollHeight } = containListRef.current
        if (scrollTop + clientHeight >= scrollHeight - 10 && !loadAgend.pagina && sttCtxAgend.offset < sttCtxAgend.maxScroll) {
          if (sttCtxAgend.bttAgSel === 'avulsos') actionsAgend.BuscarAgendamentosAvulsos(false)
          else if (sttCtxAgend.bttAgSel === 'fixos') actionsAgend.BuscarMensalistasUsuario(false)
          else if (sttCtxAgend.bttAgSel === 'diarias') actionsAgend.BuscarDiariasUsuario(false)
        }
      }
    }

    const refCurrent = containListRef.current
    if (refCurrent) {
      refCurrent.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener('scroll', handleScroll)
      }
    }
  }, [containListRef, loadAgend.pagina, sttCtxAgend.offset, sttCtxAgend.maxScroll])

  return (
    <div className='contain-page-mobile tw-p-3'>
      <Grid container sx={stMob.containHeader}>
        <IoChevronBack
          className='icon-back-page'
          style={{ marginTop: '0px' }}
          onClick={() => {
            serverRouter('back')
          }}
        />
        <Typography variant='h6' className='text-title-page tw-w-full'>
          Minha Agenda
        </Typography>
      </Grid>
      <Box sx={stMob.containButtons}>
        <Button
          variant='contained'
          sx={sttCtxAgend.bttAgSel === 'avulsos' ? stMob.bttFiltroSel : stMob.bttFiltro}
          onClick={() => {
            if (sttCtxAgend.bttAgSel !== 'avulsos' && !loadAgend.list) actionsAgend.handleSttCtxAgend('bttAgSel', 'avulsos')
          }}
        >
          <Typography sx={sttCtxAgend.bttAgSel === 'avulsos' ? stMob.textSel : stMob.textBtt}>Avulsos</Typography>
        </Button>
        <Button
          variant='contained'
          sx={sttCtxAgend.bttAgSel === 'fixos' ? stMob.bttFiltroSel : stMob.bttFiltro}
          onClick={() => {
            if (sttCtxAgend.bttAgSel !== 'fixos' && !loadAgend.list) actionsAgend.handleSttCtxAgend('bttAgSel', 'fixos')
          }}
        >
          <Typography sx={sttCtxAgend.bttAgSel === 'fixos' ? stMob.textSel : stMob.textBtt}>Fixos</Typography>
        </Button>
        <Button
          variant='contained'
          sx={sttCtxAgend.bttAgSel === 'diarias' ? stMob.bttFiltroSel : stMob.bttFiltro}
          onClick={() => {
            if (sttCtxAgend.bttAgSel !== 'diarias' && !loadAgend.list) actionsAgend.handleSttCtxAgend('bttAgSel', 'diarias')
          }}
        >
          <Typography sx={sttCtxAgend.bttAgSel === 'diarias' ? stMob.textSel : stMob.textBtt}>Diárias</Typography>
        </Button>
      </Box>
      {sttCtxAgend.bttAgSel === 'avulsos' && <FiltroAvulsos />}
      <Box sx={stMob.containListItens} ref={containListRef}>
        {loadAgend.list ? (
          <div className='contain-loading'>
            <Loading text={'Carregando...'} />
          </div>
        ) : sttCtxAgend[sttCtxAgend.bttAgSel].length > 0 ? (
          sttCtxAgend[sttCtxAgend.bttAgSel].map((item, index) => {
            if (sttCtxAgend.bttAgSel === 'avulsos') {
              return (
                <React.Fragment key={index}>
                  <CompPedido pedido={item} />
                </React.Fragment>
              )
            } else if (sttCtxAgend.bttAgSel === 'fixos') {
              return (
                <React.Fragment key={index}>
                  <CompMensalista mens={item} />
                </React.Fragment>
              )
            } else if (sttCtxAgend.bttAgSel === 'diarias') {
              return (
                <React.Fragment key={index}>
                  <CompDiaria diaria={item} mode={true} />
                </React.Fragment>
              )
            }
          })
        ) : (
          <Box sx={stMob.containSearchAlert}>
            <SearchAlert
              text={
                sttCtxAgend.bttAgSel === 'avulsos'
                  ? 'Nenhum agendamento encontrado'
                  : sttCtxAgend.bttAgSel === 'fixos'
                  ? 'Nenhum contrato fixo encontrado'
                  : 'Nenhuma diária encontrada'
              }
            />
          </Box>
        )}
        {loadAgend.pagina && !loadAgend.list && (
          <div className='contain-loading'>
            <Loading />
          </div>
        )}
      </Box>
      <AppBarBottom />
    </div>
  )
}
